export default __webpack_public_path__ + "static/media/fastlane_front.c2aac0eb.jpg";